"use client"

import { useState } from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faTrash, faEdit } from "@fortawesome/free-solid-svg-icons"
import Modal from "../modules/Modal/Moadal"
import Button from "../modules/Button/Button"
import Input from "../modules/Input/Input"
import Select from "../modules/Select/Select"
import styles from "../../../styles/inventory/OrderSupplies.module.css"
import toast from "react-hot-toast"

import { createTenoviBulkOrder } from "../../../services/inventory/detail"

const OrderSupplies = ({ isOpen, setIsOpen, onOrderUpdate }) => {
  const [currentStep, setCurrentStep] = useState(1)
  const [loading, setLoading] = useState(false)
  const [selectedSupply, setSelectedSupply] = useState("")
  const [addQuantity, setAddQuantity] = useState("")
  const [orderedItems, setOrderedItems] = useState([])

  const [emailTo, setEmailTo] = useState("khadijanawaz8302@gmail.com")
  const [emailSubject, setEmailSubject] = useState("Bulk Device Order Requirement")
  const [emailBody, setEmailBody] = useState("")
  const [isEditingEmail, setIsEditingEmail] = useState(false)

  const supplyOptions = [
    { value: "monitor", label: "Monitor" },
    { value: "hydration-monitor", label: "Hydration Monitor" },
    { value: "test-strips", label: "Test Strips" },
    { value: "batteries", label: "Batteries" },
    { value: "cables", label: "Cables" },
  ]

  const supplyIdMap = {
    monitor: 1,
    "hydration-monitor": 2,
    "test-strips": 3,
    batteries: 4,
    cables: 5,
  }

  const handleAddItem = () => {
    if (!selectedSupply || !addQuantity) {
      toast.error("Please fill all fields")
      return
    }
    const quantityNum = Number(addQuantity)
    if (!Number.isFinite(quantityNum) || quantityNum <= 0) {
      toast.error("Quantity must be a positive number")
      return
    }
    const supplyLabel = supplyOptions.find((s) => s.value === selectedSupply)?.label || selectedSupply
    const newItem = { id: Date.now(), supplyKey: selectedSupply, supply: supplyLabel, quantity: quantityNum }
    setOrderedItems((prev) => [...prev, newItem])
    setSelectedSupply("")
    setAddQuantity("")
  }

  const handleRemoveItem = (itemId) => {
    setOrderedItems((prev) => prev.filter((item) => item.id !== itemId))
  }

  const generateEmailBody = () => {
    if (orderedItems.length === 0) return ""
    const itemsList = orderedItems.map((item, idx) => `${idx + 1}: We need ${item.quantity} ${item.supply}`).join("\n\n")
    return `Dear fjames,\n\nI would like to place a bulk order for the following:\n\n${itemsList}\n\nPlease arrange delivery at your earliest convenience. Kindly confirm the order and provide any further details needed to proceed.\n\nThank you for your support.\n\nBest regards,\nTOCA`
  }

  const handleStepChange = (step) => {
    if (step === 2 && !emailBody) setEmailBody(generateEmailBody())
    setCurrentStep(step)
  }

  const handleSubmitOrder = async () => {

    if (orderedItems.length === 0) {
      toast.error("Please add at least one supply to order")
      return
    }
    if (!emailTo?.trim() || !emailSubject?.trim() || !emailBody?.trim()) {
      toast.error("Please complete email fields")
      return
    }

    setLoading(true)
    try {

      const itemsPayload = orderedItems.map((it) => {
        const mapped = supplyIdMap[it.supplyKey]

        return {
          device_type: mapped !== undefined ? mapped : it.supplyKey,
          quantity: Number.parseInt(it.quantity, 10),
        }
      })

      const payload = {
        to_email: emailTo.trim(),
        subject: emailSubject.trim(),
        body: emailBody,
        items: itemsPayload,
      }

      const result = await createTenoviBulkOrder(payload)

      const res = result && result.data ? result.data : result

      const success = res?.success === true || !!res?.message

      if (success) {
        toast.success("Supply bulk order created successfully")

        setCurrentStep(1)
        setOrderedItems([])
        setSelectedSupply("")
        setAddQuantity("")
        setEmailTo("khadijanawaz8302@gmail.com")
        setEmailSubject("Bulk Device Order Requirement")
        setEmailBody("")
        setIsEditingEmail(false)
        setIsOpen(false)
        if (typeof onOrderUpdate === "function") onOrderUpdate()
      } else {
        toast.error(res?.message || "Failed to create bulk order")
      }
    } catch (error) {
      console.error("Error creating supply bulk order:", error)
      toast.error("Failed to create bulk order")
    } finally {
      setLoading(false)
    }
  }

  const handleClose = () => {
    setCurrentStep(1)
    setOrderedItems([])
    setSelectedSupply("")
    setAddQuantity("")
    setEmailTo("khadijanawaz8302@gmail.com")
    setEmailSubject("Bulk Device Order Requirement")
    setEmailBody("")
    setIsEditingEmail(false)
    setIsOpen(false)
  }

  const canProceedToNext = () => {
    return currentStep === 1 ? orderedItems.length > 0 : emailTo && emailSubject && emailBody
  }

  const getStepTitle = () => (currentStep === 1 ? "Order Supplies - Item Details" : "Order Supplies - Email")

  const handleSaveEmail = () => {

    if (!emailTo?.trim() || !emailSubject?.trim() || !emailBody?.trim()) {
      toast.error("Please complete email fields before saving")
      return
    }
    setIsEditingEmail(false)
    // toast.success("Email saved")
  }

  const renderStepContent = () => {
    if (currentStep === 1) {
      return (
        <div className={styles.step_content}>
          {}
          <div className={styles.add_item_section}>
            <div className={styles.form_row}>
              <div className={styles.form_group}>
                <label className={styles.form_label}>Select Supply</label>
                <Select
                  options={supplyOptions}
                  value={selectedSupply}
                  width="100%"
                  onChange={setSelectedSupply}
                  placeholder="Select Supply"
                />
              </div>
            </div>

            <div className={styles.form_row}>
              <div className={styles.form_group}>
                <Input
                  label="Quantity"
                  type="number"
                  value={addQuantity}
                  onChange={(e) => setAddQuantity(e.target.value)}
                  placeholder="Enter Quantity"
                  min="1"
                />
              </div>
            </div>

            <div className={styles.add_button_container}>
              <Button variant="primary" size="small" onClick={handleAddItem} disabled={!selectedSupply || !addQuantity}>
                Add
              </Button>
            </div>
          </div>

          {}
          {orderedItems.length > 0 && (
            <div className={styles.items_table_section}>
              <div className={styles.items_table}>
                <div className={styles.table_header}>
                  <span>#</span>
                  <span>Supply</span>
                  <span>Quantity</span>
                  <span>Action</span>
                </div>
                {orderedItems.map((item, index) => (
                  <div key={item.id} className={styles.table_row}>
                    <span>{index + 1}</span>
                    <span>{item.supply}</span>
                    <span>{item.quantity}</span>
                    <Button size="small" variant="ghost" onClick={() => handleRemoveItem(item.id)}>
                      <FontAwesomeIcon icon={faTrash} />
                    </Button>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      )
    }

    if (currentStep === 2) {
      return (
        <div className={styles.step_content}>
          <div className={styles.email_container}>
            <div className={styles.email_header}>
              <h3>Email</h3>
              {}
              <Button variant="secondary" size="small" onClick={() => setIsEditingEmail((s) => !s)}>
                <FontAwesomeIcon icon={faEdit} />
              </Button>
            </div>

            <div className={styles.email_fields}>
              <div className={styles.email_field}>
                <span className={styles.email_label}>To:</span>
                {isEditingEmail ? <Input value={emailTo} onChange={(e) => setEmailTo(e.target.value)} /> : <span className={styles.email_value}>{emailTo}</span>}
              </div>
              <div className={styles.email_field}>
                <span className={styles.email_label}>Subject:</span>
                {isEditingEmail ? <Input value={emailSubject} onChange={(e) => setEmailSubject(e.target.value)} /> : <span className={styles.email_value}>{emailSubject}</span>}
              </div>
            </div>

            <div className={styles.email_body_container}>
              {isEditingEmail ? (
                <textarea className={styles.email_textarea} value={emailBody} onChange={(e) => setEmailBody(e.target.value)} rows={35} />
              ) : (
                <div className={styles.email_body_preview}>
                  {emailBody.split("\n").map((line, idx) => (
                    <p key={idx}>{line}</p>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
      )
    }

    return null
  }

  const footerPrimaryDisabled = loading || isEditingEmail || !canProceedToNext()

  return (
    <Modal
      isOpen={isOpen}
      onClose={handleClose}
      title={getStepTitle()}
      width="800px"
      height="auto"
      footer={
        <div className={styles.modal_footer}>
          <div className={styles.footer_left}>
            {currentStep > 1 && <Button variant="secondary" onClick={() => setCurrentStep(currentStep - 1)}>Previous</Button>}
          </div>

          <div className={styles.footer_right}>
            <Button variant="secondary" size="small" onClick={handleClose}>
              Cancel
            </Button>

            {}
            {isEditingEmail && (
              <Button variant="primary" size="small" onClick={handleSaveEmail}>
                Save
              </Button>
            )}

            {currentStep < 2 ? (
              <Button variant="primary" size="small" onClick={() => handleStepChange(currentStep + 1)} disabled={footerPrimaryDisabled}>
                Next
              </Button>
            ) : (
              <Button variant="primary" size="small" onClick={handleSubmitOrder} loading={loading} disabled={footerPrimaryDisabled}>
                Send Email
              </Button>
            )}
          </div>
        </div>
      }
    >
      <div className={styles.order_supplies_content}>{renderStepContent()}</div>
    </Modal>
  )
}

export default OrderSupplies